import { isAxiosError } from 'axios'
import { ApiError, GeneralErrorResponse } from './types'

// eslint-disable-next-line import/prefer-default-export
export function getApiErrorMessage(error: unknown): ApiError {
  if (!isAxiosError<GeneralErrorResponse>(error)) {
    if (error instanceof Error) {
      return { messages: [error.message] }
    }
    return { messages: ['Unexpected error'] }
  }

  const data = error.response?.data

  const fieldMessages = data?.errors
    ?.map((e) => e.message?.trim())
    .filter((m): m is string => Boolean(m)) ?? []

  if (fieldMessages.length > 0) {
    return {
      id: data?.id,
      messages: fieldMessages,
    }
  }

  if (data?.message?.trim()) {
    return {
      id: data?.id,
      messages: [data?.message],
    }
  }

  if (error.message?.trim()) {
    return {
      id: data?.id,
      messages: [error?.message],
    }
  }

  return {
    id: data?.id,
    messages: ['Unexpected error'],
  }
}
